import { ClassifierValue } from "types/classifier";
import { FileRecord } from "../file-record";
import {
  FormMandatoryTopicClassifierDraft,
  FormProgramBase,
  ProgramBase,
} from "./program";
import { LearningProgramDraft } from "./learning-program";

export interface FormDevelopmentCompetencyGroupClassifier {
  developmentCompetencyGroupClassifierId: string;
  developmentCompetencyGroupDurationHours: number;
}
export interface DevelopmentCompetencyGroupClassifier {
  id: number;
  classifier: ClassifierValue;
  duration: number;
}

export interface DevelopmentDraftCompetencyGroupClassifier {
  developmentCompetencyGroupClassifierId: ClassifierValue;
  developmentCompetencyGroupDurationHours: number;
}

export interface DevelopmentProgram extends ProgramBase {
  programGoal: string;
  theoreticalDistribution: string;
  practicalDistribution?: string;
  programFormClassifier?: ClassifierValue | null;
  evaluationFormClassifier: ClassifierValue;
  developmentProgramMethodOfExecution: ClassifierValue;
  developmentCompetencyGroupClassifiers: DevelopmentCompetencyGroupClassifier[];
  duration: number;
}

export interface DevelopmentProgramDraft {
  duration: Number;
  descriptionSummary: string;
  developmentCompetencyGroups: DevelopmentDraftCompetencyGroupClassifier[];
  evaluationFormClassifierId: ClassifierValue;
  files: FileRecord[];
  otherFiles?: FileRecord[];
  formClassifierId: ClassifierValue;
  listenerCountFrom: number;
  listenerCountTo: number;
  location: string;
  mandatoryTopics: FormMandatoryTopicClassifierDraft[];
  methodOfExecution: ClassifierValue;
  name: string;
  practicalDevelopmentDurationHours: string;
  programGoals: string;
  targetAudienceClassifierIds: ClassifierValue[] | null;
  targetedProgramClassifierIds: ClassifierValue[] | null;
  theoreticalDevelopmentDurationHours: string;
  typeClassifierId: ClassifierValue;
  otherTargetedAudienceClassifierIds: string[] | null;
}

export interface FormDevelopmentProgram extends FormProgramBase {
  location?: string;
  developmentCompetencyGroups?: FormDevelopmentCompetencyGroupClassifier[];
  methodOfExecution?: string;
  evaluationFormClassifierId?: string;
  formClassifierId?: string;
  programGoals?: string;
  theoreticalDevelopmentDurationHours?: string;
  practicalDevelopmentDurationHours?: string;
  targetAudienceClassifierIds?: string[];
}

export interface ProgramDraft {
  content: DevelopmentProgramDraft | LearningProgramDraft;
  creator: number;
  id: string;
  type: string;
}

export enum DevelopmentCompetencyGroup {
  CLINICAL_SPECIALTIES = "klinikinės (specialybinės)",
  GENERAL_CLINICAL_SPECIALTIES = "bendrosios klinikinės (specialybinės)",
  GENERAL_SPECIALTIES = "bendrosios (ne klinikinės (ne specialybinės))",
}
